<template>
  <v-card class="banner" flat>
    <v-row class="table-header">
      <v-col>圖片</v-col>
      <v-col style="max-width: 300px"></v-col>
    </v-row>
    <template v-for="(item, i) in banners">
      <v-row class="align-center my-2">
        <template v-if="!item.editing">
          <v-col>
            <v-img :src="item.src" max-width="500px" aspect-ratio="4"></v-img>
          </v-col>
          <v-col>
            <div>{{ item.text }}</div>
          </v-col>
        </template>
        <template v-else>
          <v-col class="d-flex">
            <div 
              class="file-input" 
              @click="$refs[`image${i}`][0] ? $refs [`image${i}`][0].click() : ''"
            >
              <template v-if="item.src">
                <v-icon class="delete" @click.stop="item.src = ''; $forceUpdate()">fa-times-circle</v-icon>
                <v-img :src="item.src" contain></v-img>
              </template>
              <template v-else>
                <input 
                  type="file" 
                  :ref="`image${i}`" 
                  :accept="$accept_file_type.image" 
                  onclick="this.value = null" 
                  @change="uploadImage(i)"
                />
                <div class="uploadText">
                  <v-icon>fa-plus</v-icon>
                  Select File
                </div>
              </template>
            </div>
          </v-col>
          <v-col>
           <v-textarea hide-details height="100" outlined v-model="item.text" :rules="[$rules.notEmpty]"></v-textarea>
          </v-col>
        </template>
    
        <v-col style="max-width: 300px">
          <v-btn icon color="indigo" class="mx-1" @click="moveUp(i)">
            <v-icon>fa-arrow-up</v-icon>
          </v-btn>
          <v-btn icon color="red" class="mx-1" @click="moveDown(i)">
            <v-icon>fa-arrow-down</v-icon>
          </v-btn>
          <v-btn icon color="indigo" class="mx-1" v-if="!item.editing" @click="item.editing = true">
            <v-icon>fa-edit</v-icon>
          </v-btn>
          <v-btn icon color="green" class="mx-1" v-else @click="save(i)">
            <v-icon>fa-save</v-icon>
          </v-btn>
          <DeleteConfirmBtn icon color="red" btnClass="mx-1" @delete="deleteItem(i)">
            <v-icon>fa-trash-alt</v-icon>
          </DeleteConfirmBtn>
        </v-col>
      </v-row>
      <v-divider ></v-divider>
    </template>
    <v-btn block class="pink mt-6" @click="addBanner">
      <v-icon color="white">fa-plus</v-icon>
    </v-btn>
  </v-card>
</template>

<script>
import DeleteConfirmBtn from '@/components/DeleteConfirmBtn'
export default {
  components: { DeleteConfirmBtn },
  data() {
    return {
      banners: [],
    }
  },
  created() {
    this.getBanner()
  },
  methods: {
    async getBanner() {
      let response = await this.axios.get('/banner')
      this.banners = await Promise.all(response.data.map(async banner => {
        return {src: await this.$func.urlToBase64(this.$HOST_URL + banner.path), text: banner.text, editing: false}
      }))
    },
    async uploadImage(i) {
      let image = event.target.files[0]
      if(!await this.$func.fileValidation(image)) {
        return
      }
      this.banners[i].src = await this.$func.fileToBase64(image)
      this.$forceUpdate()
    },
    deleteItem(i) {
     this.banners.splice(i, 1)
     this.submit()
    },
    addBanner() {
      this.banners.push({src: '', text: '/', editing: true})
    },
    moveUp(i) {
      if(i == 0) {
        return
      }
      this.banners[i] = this.banners.splice(i - 1, 1, this.banners[i])[0]
      if(!this.banners[i].editing && !this.banners[i - 1].editing) {
        this.submit()
      }
    },
    moveDown(i) {
      if(i == this.banners.length -1) {
        return
      }
      this.banners[i] = this.banners.splice(i + 1, 1, this.banners[i])[0]
      if(!this.banners[i].editing && !this.banners[i + 1].editing) {
        this.submit()
      }
    },
    save(i) {
      if(this.banners[i].src !== '') {
        this.banners[i].editing = false
        this.submit().then().catch(() => {
          this.banners[i].editing = true
        })
      }
    },
    submit() {
      return new Promise((resolve, reject) => {
        this.axios.post('/admin/banner', {
          images: this.banners.filter(item => !item.editing).map(item => item.src),
          texts: this.banners.filter(item => !item.editing).map(item => item.text)
        }).then(response => {
          this.$root.$emit('alert', 'success', '更新成功')
          resolve()
        }).catch(() => {
          this.$root.$emit('alert', 'error', '更新失敗')
          reject()
        })
      })
    }
  }
}
</script>

<style lang="scss">
.banner {
  padding: 40px;
  .file-input {
    position: relative;
    margin-right: 0;
    width: 100%;
  }
}
</style>